import { useSetRecoilState } from 'recoil'
import { messageListState, SenderType } from '../states/messageState'
import { windowScrollToBottom } from '../util/windowScrollToBottom'

export const useSendMessage = () => {
  const setMessageList = useSetRecoilState(messageListState)

  const handleAddSenderParent = (sender: SenderType, message: string): Promise<void> => {
    const timer = sender === 'bot' ? 1500 : 0
    return new Promise((resolve) => {
      setTimeout(() => {
        setMessageList((prev) => [...prev, { sender: sender, messages: [message] }])
        windowScrollToBottom()
        resolve()
      }, timer)
    })
  }

  const handleAddMessage = (sender: SenderType, message: string): Promise<void> => {
    const timer = sender === 'bot' ? 3000 : 0
    return new Promise((resolve) => {
      setTimeout(() => {
        setMessageList((prev) => {
          const added = prev.map((item, index) =>
            index === prev.length - 1 ? { ...item, messages: [...item.messages, message] } : item
          )
          return added
        })
        windowScrollToBottom()
        resolve()
      }, timer)
    })
  }

  return { handleAddSenderParent, handleAddMessage }
}
